import { ModalProps } from 'views/ProductPage/configurators/index';
import { LawnMowerAddonProduct } from 'models/InstallationConfigurator';
import { RadioButtonProps } from 'components/Shared/Form';
import styles from 'views/ProductPage/configurators/installation/themes/BGH/styles.scss';
import { rm, NO_ELEMENT } from 'utils';
import React from 'react';
import { InstallationAddon } from '../themes/BGH/installationAddon';
import {
  getConfiguratorAddons,
  getConfiguratorInstallations
} from 'views/ProductPage/configurators/selector';
import { AddonSectionProps } from '../addonSectionProps';
import { isLawnMowerProduct } from '../selector';
import { ConfiguratorBase } from 'models/ConfiguratorBase';

interface DescriptionTypeProps {
  descriptionType: 'modal' | 'tooltip';
  setModal: ModalProps['setModal'];
  name: string;
}

type LawnmowerAddonProps = LawnMowerAddonProduct &
  Pick<RadioButtonProps, 'onChange'> &
  Pick<ModalProps, 'setModal'> &
  DescriptionTypeProps;

export const LawnmowerAddon = ({
  onChange,
  title,
  price,
  selected,
  productId,
  setModal,
  description,
  descriptionType
}: LawnmowerAddonProps) => {
  const showInfo = () => {
    setModal(description);
  };

  const groupName = 'lawnMover';

  return (
    <InstallationAddon
      tooltip={{
        type: descriptionType === 'modal' ? 'modal' : 'dialog',
        onClick: showInfo,
        description
      }}
      title={title}
      value={productId}
      name={groupName}
      onClick={onChange}
      isSelected={selected}
      price={price}
    />
  );
};

export enum INSTALLATION {
  HELP,
  NO_HELP,
  NONE
}

interface SelectorProps {
  onChange: (installation: INSTALLATION) => void;
  selected: INSTALLATION;
  configurator: ConfiguratorBase;
}

export const Selector = ({ onChange, selected, configurator }: SelectorProps) => {
  const FIRST = 0;
  const installationPrice = getConfiguratorInstallations({ configurator })[FIRST]?.price;
  const addonPrice = getConfiguratorAddons({ configurator })[FIRST]?.price;

  const groupName = 'selector';

  return (
    <fieldset id="addons">
      <InstallationAddon
        title={rm('installation_help')}
        name={groupName}
        onClick={onChange}
        value={INSTALLATION.HELP}
        isSelected={selected === INSTALLATION.HELP}
        price={{ ...installationPrice, isFromPrice: true }}
      />
      <InstallationAddon
        title={rm('installation_self')}
        value={INSTALLATION.NO_HELP}
        name={groupName}
        onClick={onChange}
        isSelected={selected === INSTALLATION.NO_HELP}
        price={{ ...addonPrice, isFromPrice: true }}
      />
    </fieldset>
  );
};

interface LawnmowerAddonSectionProps extends AddonSectionProps {
  addonProducts: LawnMowerAddonProduct[];
  setModal: ModalProps['setModal'];
}

export const LawnmowerAddonSection = ({
  addonProducts,
  setModal,
  noAddonsSelected,
  selectAddon,
  resetAddons
}: LawnmowerAddonSectionProps) => {
  const groupName = 'lawnMover';

  return addonProducts.length > 0 ? (
    <div>
      <p className={styles.sectionHeading}>{rm('product_installation_kit_header')}</p>
      <fieldset id="addons">
        <InstallationAddon
          onClick={resetAddons}
          name={groupName}
          value=""
          isSelected={noAddonsSelected}
          title={rm('product_polarpump_installation_addons_product_default_name')}
        />
        {addonProducts.map(product =>
          isLawnMowerProduct(product) ? (
            <LawnmowerAddon
              descriptionType="tooltip"
              setModal={setModal}
              {...product}
              key={product.productId}
              onChange={selectAddon}
              name={groupName}
            />
          ) : (
            NO_ELEMENT
          )
        )}
      </fieldset>
    </div>
  ) : (
    NO_ELEMENT
  );
};
